/**
 * Central reduced-motion helper. Consult this before starting any
 * JavaScript-orchestrated animation so it is skipped entirely (not merely
 * shortened) when the visitor prefers reduced motion.
 */
const query = window.matchMedia('(prefers-reduced-motion: reduce)');

export function prefersReducedMotion(): boolean {
  return query.matches;
}

/** Run a callback now and whenever the reduced-motion preference changes. */
export function onMotionPreferenceChange(callback: (reduced: boolean) => void): void {
  callback(query.matches);
  query.addEventListener('change', (event) => callback(event.matches));
}
